var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8937 1.98553H9.92944V14.5014H16.8937V1.98553Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3717 8.24453C10.3691 5.80184 11.4901 3.49368 13.4117 1.98552C10.1483 -0.579095 5.4621 -0.205537 2.64628 2.84367C-0.169529 5.89287 -0.169529 10.594 2.64628 13.6432C5.4621 16.6924 10.1483 17.066 13.4117 14.5013C11.4908 12.9936 10.3698 10.6865 10.3717 8.24453Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.29 8.24454C26.29 11.2919 24.5499 14.0717 21.8089 15.4034C19.068 16.735 15.8072 16.3848 13.4116 14.5013C15.3317 12.9924 16.4528 10.6855 16.4528 8.24343C16.4528 5.80138 15.3317 3.49449 13.4116 1.98553C15.8072 0.102097 19.068 -0.248161 21.8089 1.08351C24.5499 2.41518 26.29 5.19498 26.29 8.24233V8.24454Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/masterCard.9d21fbc1cb8c0159bda59a8bda8b85a5.svg";
export { ForwardRef as ReactComponent };